import sumBy from "lodash/sumBy";
import { currencyFormat } from "../../../../core/utils";
import { PagoPendienteRespuesta } from "../types/pagos.types";

type PagosMultiplesTableProps = { pagos: PagoPendienteRespuesta[] };

const PagosMultiplesTable = ({ pagos }: PagosMultiplesTableProps) => {
	return (
		<table className="border-hf">
			<thead>
				<tr>
					<th>Concepto de Pago</th>
					<th>Importe</th>
				</tr>
			</thead>
			<tbody>
				{pagos.map(pago =>
					<tr key={pago.idCobro}>
						<td>{pago.concepto}</td>
						<td>{currencyFormat(pago.importe)}</td>
					</tr>
				)}
			</tbody>
			<tfoot>
				<tr>
					<th>Importe:</th>
					<th>{currencyFormat(sumBy(pagos, "importe"))}</th>
				</tr>
			</tfoot>
		</table>
	);
};

export default PagosMultiplesTable;